import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (username, password) => api.post('/auth/login/', { username, password }),
  me: () => api.get('/auth/me/'),
};

export const viloyatUsersAPI = {
  list: (params) => api.get('/viloyat/users/', { params }),
  create: (data) => api.post('/viloyat/users/', data),
  update: (id, data) => api.put(`/viloyat/users/${id}/`, data),
  delete: (id) => api.delete(`/viloyat/users/${id}/`),
  toggleActive: (id) => api.post(`/viloyat/users/${id}/toggle_active/`),
  resetPassword: (id, password) => api.post(`/viloyat/users/${id}/reset_password/`, { password }),
};

export const tumanUsersAPI = {
  list: (params) => api.get('/tuman/users/', { params }),
  create: (data) => api.post('/tuman/users/', data),
  update: (id, data) => api.put(`/tuman/users/${id}/`, data),
  delete: (id) => api.delete(`/tuman/users/${id}/`),
  toggleActive: (id) => api.post(`/tuman/users/${id}/toggle_active/`),
  resetPassword: (id, password) => api.post(`/tuman/users/${id}/reset_password/`, { password }),
};

export const youthAPI = {
  list: (params) => api.get('/youth/', { params }),
  get: (id) => api.get(`/youth/${id}/`),
  create: (data) => api.post('/youth/', data),
  update: (id, data) => api.put(`/youth/${id}/`, data),
  patch: (id, data) => api.patch(`/youth/${id}/`, data),
  delete: (id) => api.delete(`/youth/${id}/`),
  stats: (params) => api.get('/youth/stats/', { params }),
  mini: () => api.get('/youth/mini/'),
  filterOptions: (params) => api.get('/youth/filter-options/', { params }),
  exportExcel: (params) => api.get('/youth/export/excel/', {
    params,
    responseType: 'blob',
  }),
};

export const problemsAPI = {
  list: (params) => api.get('/youth/problems/', { params }),
  get: (id) => api.get(`/youth/problems/${id}/`),
  create: (data) => api.post('/youth/problems/', data),
  update: (id, data) => api.put(`/youth/problems/${id}/`, data),
  patch: (id, data) => api.patch(`/youth/problems/${id}/`, data),
  delete: (id) => api.delete(`/youth/problems/${id}/`),
  stats: () => api.get('/youth/problems/stats/'),
  respond: (id, data) => api.post(`/youth/problems/${id}/respond/`, data),
};

export const aiAPI = {
  stats: () => api.get('/youth/ai/stats/'),
};

export const questionsAPI = {
  list: (params) => api.get('/youth/questions/', { params }),
  get: (id) => api.get(`/youth/questions/${id}/`),
  create: (data) => api.post('/youth/questions/', data),
  update: (id, data) => api.put(`/youth/questions/${id}/`, data),
  delete: (id) => api.delete(`/youth/questions/${id}/`),
  stats: () => api.get('/youth/questions/stats/'),
  answer: (id, answer) => api.post(`/youth/questions/${id}/answer/`, { answer }),
  markRead: (id) => api.post(`/youth/questions/${id}/mark_read/`),
  reject: (id, answer) => api.post(`/youth/questions/${id}/reject/`, { answer }),
};

export const eventsAPI = {
  list: (params) => api.get('/youth/events/', { params }),
  get: (id) => api.get(`/youth/events/${id}/`),
  create: (data) => api.post('/youth/events/', data),
  update: (id, data) => api.put(`/youth/events/${id}/`, data),
  delete: (id) => api.delete(`/youth/events/${id}/`),
  stats: () => api.get('/youth/events/stats/'),
  rating: () => api.get('/youth/events/rating/'),
  addParticipant: (id, data) => api.post(`/youth/events/${id}/add_participant/`, data),
  removeParticipant: (id, youth) => api.post(`/youth/events/${id}/remove_participant/`, { youth }),
  updateScore: (id, youth, score) => api.post(`/youth/events/${id}/update_score/`, { youth, score }),
};

export const migrantsAPI = {
  stats: () => api.get('/youth/migrants/stats/'),
  list: (params) => api.get('/youth/migrants/list/', { params }),
  referrals: {
    list: (params) => api.get('/youth/migrants/referrals/', { params }),
    get: (id) => api.get(`/youth/migrants/referrals/${id}/`),
    create: (data) => api.post('/youth/migrants/referrals/', data),
    update: (id, data) => api.put(`/youth/migrants/referrals/${id}/`, data),
    delete: (id) => api.delete(`/youth/migrants/referrals/${id}/`),
  },
};

export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats/'),
};

export default api;
// api-v2
